import { sectionIds } from '@/common/components/FilterViews/constants'
import { statuses, transactionTypes } from '@/returns/constants'

export const filterNames = {
  status: 'status',
  query: 'query',
  pageSize: 'returnsPageSize',
  orderBy: 'orderBy',
  transactionType: 'transactionType',
  refundDate: 'refundDate',
  refundDateStart: 'refundDateStart',
  refundDateEnd: 'refundDateEnd',
  refundDatesDaysGte: 'refundDatesDaysGte',
  refundDatesDaysLte: 'refundDatesDaysLte',
  deliveryMethodType: 'deliveryMethodType',
  deliveryMethod: 'deliveryMethod',
  lastUpdate: 'lastUpdate',
  lastUpdatedGte: 'lastUpdatedGte',
  lastUpdatedLte: 'lastUpdatedLte',
  expiresIn: 'expiresIn',
  refundMethod: 'refundMethod',
  returnReason: 'returnReason',
  returnReasonType: 'returnReasonType',
  rejectReason: 'rejectReason',
  forReviewReason: 'forReviewReason',
  region: 'region',
  instant: 'instant',
  exchangeForOrderStatus: 'exchangeForOrderStatus',
  paymentStatus: 'paymentStatus',
  refundStatus: 'refundStatus',
  variantsSkus: 'variantsSkus',
  shippingLabelStatus: 'shippingLabelStatus',
  exchangeCreatedDate: 'exchangeCreatedDate',
  exchangeCreatedGte: 'exchangeCreatedGte',
  exchangeCreatedLte: 'exchangeCreatedLte',
  exchangeCreatedDaysGte: 'exchangeCreatedDaysGte',
  exchangeCreatedDaysLte: 'exchangeCreatedDaysLte',
  hasAlerts: 'hasAlerts',
  pendingAlertTypes: 'pendingAlertTypes',
  pendingAlertTypesMatch: 'pendingAlertTypesMatch',
  returnsCursor: 'returnsCursor',
  exchangedType: 'exchangedType',
  refundCreatedDate: 'refundCreatedDate',
  refundCreatedGte: 'refundCreatedGte',
  refundCreatedLte: 'refundCreatedLte',
  refundCreatedDaysGte: 'refundCreatedDaysGte',
  refundCreatedDaysLte: 'refundCreatedDaysLte',
  productCategory: 'productCategory',
  productCollection: 'productCollection',
  productType: 'productType',
  orderType: 'orderType',
  isGift: 'isGift',
  carrier: 'carrier',
  transactionTags: 'transactionTags',
  transactionTagsMatch: 'transactionTagsMatch',
  policyRules: 'policyRules',
  policyRulesMatch: 'policyRulesMatch',
  hasPolicyRules: 'hasPolicyRules',
  refundTotalAmount: 'refundTotalAmount',
  refundTotalAmountGt: 'refundTotalAmountGt',
  refundTotalAmountLt: 'refundTotalAmountLt',
  refundTotalAmountGte: 'refundTotalAmountGte',
  refundTotalAmountLte: 'refundTotalAmountLte',
  paymentTotalAmount: 'paymentTotalAmount',
  paymentTotalAmountGt: 'paymentTotalAmountGt',
  paymentTotalAmountLt: 'paymentTotalAmountLt',
  paymentTotalAmountGte: 'paymentTotalAmountGte',
  paymentTotalAmountLte: 'paymentTotalAmountLte',
}

export const filters = [
  { name: 'refundDateStart', type: 'string', backendName: 'completed_at__gte' },
  { name: 'refundDateEnd', type: 'string', backendName: 'completed_at__lte' },
  { name: 'refundDatesDaysGte', type: 'number', backendName: 'completed_at_days__gte' },
  { name: 'refundDatesDaysLte', type: 'number', backendName: 'completed_at_days__lte' },
  { name: 'query', type: 'string', backendName: 'search' },
  { name: 'orderBy', type: 'string', defaultValue: '-completed_at', backendName: 'ordering' },
  { name: 'transactionType', type: 'array', backendName: 'transaction_type' },
  { name: 'status', type: 'array', backendName: 'status' },
  { name: 'deliveryMethodType', type: 'array', backendName: 'delivery_method_type' },
  { name: 'deliveryMethod', type: 'string', backendName: 'delivery_method' },
  { name: 'lastUpdate', type: 'number', backendName: 'last_updated' },
  { name: 'lastUpdatedGte', type: 'number', backendName: 'last_updated_at__gte' },
  { name: 'lastUpdatedLte', type: 'number', backendName: 'last_updated_at__lte' },
  { name: 'expiresIn', type: 'number', backendName: 'expires_in' },
  { name: 'refundMethod', type: 'array', backendName: 'refund_method' },
  { name: 'returnReason', type: 'array', backendName: 'return_reason' },
  { name: 'returnReasonType', type: 'array', backendName: 'return_reason_type' },
  { name: 'rejectReason', type: 'array', backendName: 'reject_reason' },
  { name: filterNames.forReviewReason, type: 'array', backendName: 'for_review_reason' },
  { name: 'region', type: 'array', backendName: 'region' },
  { name: 'instant', type: 'string', backendName: 'instant' },
  { name: 'exchangeForOrderStatus', type: 'string', backendName: 'exchanged_for_order_status' },
  { name: 'paymentStatus', type: 'string', backendName: 'payment_status' },
  { name: 'refundStatus', type: 'string', backendName: 'refund_status' },
  { name: 'variantsSkus', type: 'array', backendName: 'variant_sku' },
  { name: 'shippingLabelStatus', type: 'string', backendName: 'return_label_status' },
  { name: 'exchangeCreatedGte', type: 'string', backendName: 'exchange_created__gte' },
  { name: 'exchangeCreatedLte', type: 'string', backendName: 'exchange_created__lte' },
  { name: 'exchangeCreatedDaysGte', type: 'number', backendName: 'exchange_created_days__gte' },
  { name: 'exchangeCreatedDaysLte', type: 'number', backendName: 'exchange_created_days__lte' },
  { name: filterNames.hasAlerts, type: 'string', backendName: 'has_alerts' },
  { name: filterNames.pendingAlertTypes, type: 'array', backendName: 'alert' },
  { name: filterNames.pendingAlertTypesMatch, type: 'string', backendName: 'alert_match' },
  { name: 'returnsCursor', type: 'string', backendName: 'cursor' },
  { name: 'returnsPageSize', type: 'number', backendName: 'page_size', defaultValue: 25 },
  { name: filterNames.exchangedType, type: 'array', backendName: 'exchanged_type' },
  { name: filterNames.refundCreatedGte, type: 'string', backendName: 'refund_issued__gte' },
  { name: filterNames.refundCreatedLte, type: 'string', backendName: 'refund_issued__lte' },
  { name: filterNames.refundCreatedDaysGte, type: 'number', backendName: 'refund_issued_days__gte' },
  { name: filterNames.refundCreatedDaysLte, type: 'number', backendName: 'refund_issued_days__lte' },
  { name: filterNames.productCategory, type: 'array', backendName: 'category' },
  { name: filterNames.productCollection, type: 'array', backendName: 'collection' },
  { name: filterNames.productType, type: 'array', backendName: 'product_type' },
  { name: filterNames.orderType, type: 'string', backendName: 'order_type' },
  { name: filterNames.isGift, type: 'string', backendName: 'is_gift' },
  { name: filterNames.carrier, type: 'array', backendName: 'carrier' },
  { name: filterNames.transactionTags, type: 'array', backendName: 'tags' },
  { name: filterNames.transactionTagsMatch, type: 'string', backendName: 'tags_match' },
  { name: filterNames.policyRules, type: 'array', backendName: 'policy_rule' },
  { name: filterNames.policyRulesMatch, type: 'string', backendName: 'policy_rule_match' },
  { name: filterNames.hasPolicyRules, type: 'string', backendName: 'has_policy_rules' },
  { name: filterNames.refundTotalAmount, type: 'string', backendName: 'refund_total_amount' },
  { name: filterNames.refundTotalAmountGt, type: 'string', backendName: 'refund_total_amount__gt' },
  { name: filterNames.refundTotalAmountLt, type: 'string', backendName: 'refund_total_amount__lt' },
  { name: filterNames.refundTotalAmountGte, type: 'string', backendName: 'refund_total_amount__gte' },
  { name: filterNames.refundTotalAmountLte, type: 'string', backendName: 'refund_total_amount__lte' },
  { name: filterNames.paymentTotalAmount, type: 'string', backendName: 'payment_total_amount' },
  { name: filterNames.paymentTotalAmountGt, type: 'string', backendName: 'payment_total_amount__gt' },
  { name: filterNames.paymentTotalAmountLt, type: 'string', backendName: 'payment_total_amount__lt' },
  { name: filterNames.paymentTotalAmountGte, type: 'string', backendName: 'payment_total_amount__gte' },
  { name: filterNames.paymentTotalAmountLte, type: 'string', backendName: 'payment_total_amount__lte' },
]

export const viewIds = {
  default: 'default',
  aboutToExpire: 'aboutToExpire',
  pendingApproval: 'pendingApproval',
  accepted: 'accepted',
  forReview: 'forReview',
  lastThirtyDays: 'lastThirtyDays',
  lastThirtyDaysInstant: 'lastThirtyDaysInstant',
  lastThirtyDaysRefunds: 'lastThirtyDaysRefunds',
  lastThirtyDaysExchanges: 'lastThirtyDaysExchanges',
  onHold: 'on_hold',
  alerts: 'alerts',
}

export const defaultViews = [
  {
    id: viewIds.default,
    name: 'Todas las transacciones',
    filters: {
      ordering: '-completed_at',
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: viewIds.onHold,
    name: 'En espera',
    filters: {
      status: [statuses.onHold],
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: viewIds.forReview,
    name: 'Por revisar',
    filters: {
      status: [statuses.forReview],
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: viewIds.pendingApproval,
    name: 'Pendientes de aprobación',
    filters: {
      status: [statuses.inProgress, statuses.shipped, statuses.received, statuses.forReview],
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: viewIds.aboutToExpire,
    name: 'A punto de expirar',
    filters: {
      expires_in: 7,
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: viewIds.accepted,
    name: 'Aceptadas',
    filters: {
      status: [statuses.accepted, statuses.partiallyAccepted],
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: viewIds.lastThirtyDays,
    name: 'Transacciones (Últimos 30 días)',
    filters: {
      completed_at_days__lte: '30',
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: viewIds.lastThirtyDaysInstant,
    name: 'Instantáneas (Últimos 30 días)',
    filters: {
      completed_at_days__lte: '30',
      instant: 'true',
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: viewIds.lastThirtyDaysRefunds,
    name: 'Devoluciones (Últimos 30 días)',
    filters: {
      completed_at_days__lte: '30',
      transaction_type: [transactionTypes.refund],
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: viewIds.alerts,
    name: 'Alertas',
    filters: {
      has_alerts: 'true',
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: viewIds.lastThirtyDaysExchanges,
    name: 'Cambios (Últimos 30 días)',
    filters: {
      completed_at_days__lte: '30',
      transaction_type: [transactionTypes.exchange],
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
]
